import React, { useEffect as uEffect } from 'react'

import { useState as uState } from "react";
import "../chart.scss";
import {
Pie,PieChart,Cell,Legend
} from "recharts";


export default function userOrdersPie({ aspect, title }) {
    const [monthUser, setMonthUser] = uState("")
    const [monthUser2, setMonthUser2] = uState("");
    const [monthUser3, setMonthUser3] = uState("");
    const [monthUser4, setMonthUser4] = uState("");
    const [monthUser5, setMonthUser5] = uState("");
    const [monthUser6, setMonthUser6] = uState("");


    var currentDate = new Date(); // get the current date

    var dates = [];

    for (var i = 0; i < 6; i++) {
        // loop through the previous six months
        var previousMonth = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() - i
        ); // get the date object for the previous month
        var monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        var previousMonthName = monthNames[previousMonth.getMonth()]; // get the name of the previous month
        var previousMonthYear = previousMonth.getFullYear(); // get the year of the previous month

        // if the previous month is in the previous year, subtract 1 from the year
        if (previousMonth.getMonth() > currentDate.getMonth()) {
            previousMonthYear -= 0;
        }

        var obj = { name: previousMonthName, Year: previousMonthYear }; // create an object with the name of the month and the year
        dates.push(obj); // add the object to the data array
    }


    const month1 =  () => {        
         fetch("http://localhost:8000/users/usersMonth", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
             body: JSON.stringify({ } ),
        })
            .then((response) =>  response.json())
            .then((data) => setMonthUser(data)
            );
    }
    const month2 = async() => {
        await fetch("http://localhost:8000/users/usersMonth2", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then(async(response) => await response.json())
            .then((data) => setMonthUser2(data));
    }
    const month3 = async() => {
        await fetch("http://localhost:8000/users/usersMonth3", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then(async(response) => await response.json())
            .then((data) => setMonthUser3(data));
    }
    const month4 = async() => {
        await fetch("http://localhost:8000/users/usersMonth4", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then(async(response) => await response.json())
            .then((data) => setMonthUser4(data));
    }
    const month5 = async() => {
        await fetch("http://localhost:8000/users/usersMonth5", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then(async(response) => await response.json())
            .then((data) => setMonthUser5(data));
    }
    const month6 = async() => {
        await fetch("http://localhost:8000/users/usersMonth6", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then(async(response) => await response.json())
            .then((data) => setMonthUser6(data));
    }
    uEffect(() => {
        month1()
        month2()
        month3()
        month4()
        month5()
        month6()
    }, [])
    const fetchData = [
        { name: dates[5].name, Year: dates[5].Year, Total: monthUser6, color:'#52D726' },
        { name: dates[4].name, Year: dates[4].Year, Total: monthUser5, color:'#FFEC00' },
        { name: dates[3].name, Year: dates[3].Year, Total: monthUser4, color:'#FF7300' },
        { name: dates[2].name, Year: dates[2].Year, Total: monthUser3, color:'#FF0000' },
        { name: dates[1].name, Year: dates[1].Year, Total: monthUser2, color:'#007ED6' },
        { name: dates[0].name, Year: dates[0].Year, Total: monthUser , color:'#7CDDDD' },
    ];
      return (
        <>

            <div className="chart">
                <div className="title">{title}</div>
                      <PieChart width={320} height={250}>
                      <Pie data={fetchData} dataKey="Total" nameKey="name" cx="50%" cy="50%" outerRadius={50} fill="#FF671F" label>
                          {fetchData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.color} />
                          ))}        
                      </Pie>
                      <Legend/>
                          {/* <Pie data={fetchData} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label /> */}
                      </PieChart>
            </div>


        </>
    )
}




